import { SettingsOutletHeader } from '../../shared/SettingsOutletHeader';
import { type AdminRestaurant } from '../../team/apiHelpers';
import { FieldBlock } from '../shared/FieldBlock';
import layoutStyles from './AddressSection.scss';

export interface AddressSectionProps {
  restaurant: AdminRestaurant;
  sectionTitleId: string;
}

export const AddressSection = ({
  restaurant,
  sectionTitleId,
}: AddressSectionProps) => (
  <section className={layoutStyles.section} aria-labelledby={sectionTitleId}>
    <SettingsOutletHeader
      variant="section"
      titleId={sectionTitleId}
      title="Address"
    />
    <div className={layoutStyles.addressGrid}>
      <FieldBlock label="Address">
        <p className={layoutStyles.readOnlyValue}>{restaurant.street}</p>
      </FieldBlock>
      <FieldBlock label="City">
        <p className={layoutStyles.readOnlyValue}>{restaurant.city}</p>
      </FieldBlock>
      <FieldBlock label="State">
        <p className={layoutStyles.readOnlyValue}>{restaurant.state}</p>
      </FieldBlock>
      <FieldBlock label="Zip Code">
        <p className={layoutStyles.readOnlyValue}>{restaurant.postalCode}</p>
      </FieldBlock>
    </div>
  </section>
);
